/* eslint-disable react/no-danger */
import '../styles/globals.css';
import 'tailwindcss/tailwind.css';
import 'react-toastify/dist/ReactToastify.min.css';
import '../styles/agGrid.scss';

import * as snippet from '@segment/snippet';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';
import React from 'react';
import TagManager from 'react-gtm-module';
import { Provider } from 'react-redux';
import { Slide, ToastContainer } from 'react-toastify';

import Dashboard from '../components/dashboard';
import store from '../store';

// eslint-disable-next-line prefer-destructuring
const NODE_ENV = process.env.NODE_ENV;
const ANALYTICS_WRITE_KEY =
  process.env.VERCEL_ENV === 'preview' || NODE_ENV === 'development'
    ? 'BIODJtMIQtjhvpa8S0ChceEWar9iRjKy'
    : 'SJEFS3g3ZihcYn89W6T6NmMfnwFvqicB';

function renderSnippet() {
  const opts = {
    apiKey: ANALYTICS_WRITE_KEY,
    page: true,
  };

  if (NODE_ENV === 'development') {
    return snippet.max(opts);
  }

  return snippet.min(opts);
}

function MyApp({ Component, pageProps }) {
  const router = useRouter();

  React.useEffect(() => {
    TagManager.initialize({ gtmId: 'GTM-KKZJ36W' });
  }, []);

  const isDashboard = [
    '/dashboard',
    '/enrich',
    '/prospector',
    '/exact-match',
    '/list',
    '/company-exact-match',
    '/saved-lists',
    '/contact-list',
    '/company-list',
    '/api',
    '/talk-to-sales',
    '/create-audience',
    '/audiences',
    '/contact-export-request',
    '/company-export-request',
    '/audience',
    '/edit-audience',
    '/integrations',
    '/verify-email',
    '/pricing',
    '/account',
    '/refer',
    '/organization',
    '/crm-management',
    '/oauth-callback',
    '/export-requests',
  ].some((path) => router.pathname.startsWith(path));

  return (
    <Provider store={store}>
      <Head>
        <title>ExactBuyer - Audience Intelligence &amp; Growth</title>
        <meta charset='utf-8' />

        <link rel='dns-prefetch' href='//pbs.twimg.com' />
        <link rel='dns-prefetch' href='//cdn.jsdelivr.net' />
        <link rel='dns-prefetch' href='//dnqcheb5nuhm8.cloudfront.net' />

        <link rel='canonical' href='https://exactbuyer.com/' />
        <meta httpEquiv='x-ua-compatible' content='ie=edge' />
        <meta name='viewport' content='width=device-width, initial-scale=1.0, shrink-to-fit=no' />
        <meta
          name='description'
          content='ExactBuyer provides powerful audience intelligence and growth marketing consulting to help your business grow. Contact enrichment, lead generation, financial compliance, and more...'
        />
        <meta name='author' content='' />
        <meta
          name='keywords'
          content='Exact Buyer,data,api,b2b,audiences,sales intellgence,audience intelligence'
        />
        <meta name='robots' content='index, follow' />
        <meta name='twitter:card' content='summary' />
        <meta name='twitter:site' content='@exactbuyer' />
        <meta
          name='twitter:image'
          content='https://pbs.twimg.com/profile_images/1181306153738760192/5t9R88S__400x400.jpg'
        />

        <meta property='og:site_name' content='Exact Buyer' />
        <meta property='og:type' content='website' />
        <meta property='og:url' content='https://exactbuyer.com' />
        <meta property='og:title' content='Exact Buyer' />
        <meta
          property='og:description'
          content='Exact Buyer provides powerful audience intelligence, sales and marketing solutions to help your business grow. Account Based Marketing, Account Based Sales, lead generation, financial compliance, and more...'
        />
        <meta
          property='og:image'
          content='https://pbs.twimg.com/profile_images/1181306153738760192/5t9R88S__400x400.jpg'
        />
        <meta name='robots' content='NOODP,NOYDIR' />
        <meta name='twitter:card' content='summary' />
        <meta name='twitter:site' content='@exactbuyer' />
        <meta
          name='twitter:image'
          content='https://pbs.twimg.com/profile_images/1181306153738760192/5t9R88S__400x400.jpg'
        />
        <meta
          property='og:description'
          content='Exact Buyer provides powerful audience intelligence, sales and marketing solutions to help your business grow. Account Based Marketing, Account Based Sales, lead generation, financial compliance, and more...'
        />
        <meta
          property='og:image'
          content='https://pbs.twimg.com/profile_images/1181306153738760192/5t9R88S__400x400.jpg'
        />

        <link rel='canonical' href='https://exactbuyer.com/' />
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossOrigin />
      </Head>
      <body>
        <Script
          id='segment-script'
          dangerouslySetInnerHTML={{ __html: renderSnippet() }}
          strategy='afterInteractive'
        />

        <Script
          id='google-tag-manager'
          src='https://www.googletagmanager.com/gtag/js?id=AW-704206910'
          strategy='afterInteractive'
        />
        <Script id='google-analytics' strategy='afterInteractive'>
          {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'AW-704206910');
        `}
        </Script>

        <ToastContainer
          position='top-right'
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          draggable
          transition={Slide}
          closeOnClick
          pauseOnHover
        />

        {!isDashboard && <Component {...pageProps} />}
        {isDashboard && <Dashboard content={<Component {...pageProps} />} />}
      </body>
    </Provider>
  );
}

export default MyApp;
